import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-2 text-sm text-white rounded-full bg-success w-fit"
}
const _hoisted_2 = {
  key: 1,
  class: "px-2 text-sm text-black rounded-full bg-warning w-fit"
}
const _hoisted_3 = {
  key: 2,
  class: "px-2 text-sm text-black rounded-full bg-danger w-fit"
}
const _hoisted_4 = {
  key: 3,
  class: "px-2 text-sm text-black rounded-full bg-danger w-fit"
}
const _hoisted_5 = {
  key: 4,
  class: "px-2 text-sm text-black rounded-full bg-danger w-fit"
}
const _hoisted_6 = {
  key: 5,
  class: "px-2 text-sm text-black rounded-full bg-danger w-fit"
}

import { Booking } from "@/types";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentStatusBadge',
  props: {
  order: {
    type: Object as PropType<Booking>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.order.payment_status === 'confirmed')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("paid")), 1))
      : _createCommentVNode("", true),
    (__props.order.payment_status === 'pending')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t("pending")), 1))
      : _createCommentVNode("", true),
    (__props.order.payment_status === 'cancelled')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t("cancelled")), 1))
      : _createCommentVNode("", true),
    (__props.order.payment_status === 'refunded')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t("refunded")), 1))
      : _createCommentVNode("", true),
    (__props.order.payment_status === 'failed')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("failed")), 1))
      : _createCommentVNode("", true),
    (__props.order.payment_status === 'abandoned')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("abandoned")), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})